import React from 'react';

import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';

import logoSvg from '../../assets/images/logo.svg';

const useStyles = makeStyles((theme) => {
  return {
    buttonContainer: {
      marginTop: '1rem',
    },
    formTitle: {
      color: '#172B4D',
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    loginHint: {
      color: 'rgba(0, 0, 0, 0.38)',
      fontSize: '0.8rem',
      lineHeight: 1.8,
      marginBottom: '1rem',
    },
    logo: {
      marginBottom: '3rem',
      textAlign: 'center',
    },
    mainContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      justifyContent: 'center',
      maxWidth: '23.125rem',
    },
  };
});

export default ({ onLogin }) => {
  const classes = useStyles();

  return (
    <Container component="main" className={classes.mainContainer}>
      <Container component="div" disableGutters>
        <img src={logoSvg} alt="logo" className={classes.logo} />
        <Typography variant="h4" className={classes.formTitle} align="center">
          Password Reset
        </Typography>
        <Typography variant="body1" className={classes.loginHint} align="center">
          If your email exist in our system, a Password reset URL will be send to the email address provided.
        </Typography>
      </Container>
      <Grid container direction="column" justify="center">
        <Grid item className={classes.buttonContainer}>
          <Button variant="contained" color="primary" fullWidth onClick={onLogin}>
            Go to Login
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
